import React from 'react';

const SoundsContext = React.createContext(null);

export { SoundsContext };
